export const ALGOLIA_SEARCH_CONFIG = {
  APP_ID: '8P0OOFSVUV',
  API_KEY: '5b82ccc7721ce8d7693691c6a81b7c2a',
  INDEX_NAME: 'embla-carousel',
}

export const ALGOLIA_CLASSNAMES = {
  LVL_0: 'algolia-docsearch-lvl-0',
  SEARCH_ACTIVE: 'DocSearch--active',
  SEARCH_INPUT: 'DocSearch-Input',
  SEARCH_TOGGLE_BUTTON: 'DocSearch-Button',
}
